<template>
  <div class="fourth-Bar">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :style="`grid-area: card-${index + 1}`"
    >
      <div class="image-block">
        <span class="category">{{ item.sub_category.name }}</span>
        <ImageContainer
          :src="item.image.medium"
          :alt="item.title"
          :thumb="item.image.thumbnail"
          class="image"
        />
      </div>
      <div class="about">
        <h1 class="text">
          {{ item.title }}
        </h1>
        <h2 class="time">
          {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
        </h2>
      </div>
    </router-link>
    <div class="decor-shield"></div>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "FourtBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.fourth-Bar {
  margin: 2rem 0;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(3, auto);
  grid-template-areas:
    "card-1 card-1 card-1 card-2 card-2 card-2"
    "card-3 card-3 card-4 card-4 card-5 card-5"
    "card-6 card-6 card-6 card-7 card-7 card-7";
  grid-row-gap: 4em;
  grid-column-gap: 4em;
  position: relative;
  width: 90%;
  .decor-shield {
    display: none;
  }
  .card {
    position: relative;
    .image-block {
      position: relative;
      width: 100%;
      .image {
        position: relative;
        width: 100%;
        min-width: 85px !important;
        padding-bottom: 66%;
        border-radius: 0.25em;
      }
      .category {
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--secondary-font-color);
        padding: 0.1rem 0.4rem;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 2.5em;
        line-height: 1.4;
        color: var(--category-color);
        z-index: 1;
        text-transform: capitalize;
      }
    }
    .about {
      position: relative;
      padding-top: 0.4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 2.5em;
      .text {
        --snup: 3;
        display: -webkit-box;
        -webkit-line-clamp: var(--snup);
        -webkit-box-orient: vertical;
        overflow: hidden;
        position: relative;
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
        color: var(--primary-font-color);
        // text-transform: capitalize !important;
      }
      .time {
        position: relative;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 300;
        font-size: 1em;
        line-height: 1;
        color: var(--date-color);
        opacity: 0.6;
        padding-top: 0.6rem;
      }
    }
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(6),
    &:nth-child(7) {
      padding: 0 13.5%;
    }
  }
}
@media screen and (max-width: 2900px) {
  .fourth-Bar {
    width: 90%;
    .card {
      .image-block {
        .category {
          font-size: 1.4em;
        }
      }
      .about {
        font-size: 1.4em;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .fourth-Bar {
    width: var(--main-wrapper-width);
    .card {
      .image-block {
        .category {
          font-size: 1em;
        }
      }
      .about {
        font-size: 1.2em;
        .time {
          font-size: 0.835em;
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .fourth-Bar {
    margin: 1rem 0;
    grid-row-gap: 2em;
    grid-column-gap: 3em;
    .card {
      .image-block {
        .image {
          padding-bottom: 66%;
        }
        .category {
          line-height: 1.3;
          text-transform: uppercase;
          font-size: 0.93em;
        }
      }
      .about {
        padding-top: 0;
        justify-content: space-between;
        font-size: 1.15em;
        .text {
          --snup: 4;
          padding-top: 0.5rem;
        }
      }
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(6),
      &:nth-child(7) {
        padding: 0;
        display: flex;
        overflow: hidden;
        .image-block {
          width: 40%;
          .category {
            position: relative;
            top: inherit;
            left: inherit;
            padding: 0;
            padding: 0 0 4% 0;
            background-color: inherit;
          }
        }
        .about {
          width: 100%;
          padding: 0.5rem 0.5rem 0 0.5rem;
          font-size: 1.15em;
          .text {
            --snup: 3;
            line-height: 1.4;
          }
          .time {
            padding: 0.5rem 0 0 0;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  html {
    // light;
    .fourth-Bar {
      --fourth-date-color: #e2e2e2;
      --fourth-category-color: #939393;
    }
    &[data-theme="dark"] {
      .fourth-Bar {
        --fourth-date-color: #2c2c2c;
        --fourth-category-color: #262626;
      }
    }
  }
  .fourth-Bar {
    margin: 1.5rem 0;
    width: 100% !important;
    grid-row-gap: 2em;
    grid-column-gap: 3em;
    .decor-shield {
      display: block;
      position: absolute;
      top: -2%;
      width: 58vw;
      height: 104%;
      z-index: 0;
      background: var(--primary-font-color);
      border-radius: 0px 4px 4px 0px;
    }
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(9, minmax(0, 70px));
    grid-template-areas:
      "card-1 card-1 card-1 card-1 card-4 card-4 card-4"
      "card-1 card-1 card-1 card-1 card-4 card-4 card-4"
      "card-1 card-1 card-1 card-1 card-5 card-5 card-5"
      "card-2 card-2 card-2 card-2 card-5 card-5 card-5"
      "card-2 card-2 card-2 card-2 card-6 card-6 card-6"
      "card-2 card-2 card-2 card-2 card-6 card-6 card-6"
      "card-3 card-3 card-3 card-3 card-7 card-7 card-7"
      "card-3 card-3 card-3 card-3 card-7 card-7 card-7"
      "card-3 card-3 card-3 card-3 . . .";
    // grid-row-gap: 2em;
    grid-column-gap: 2em;
    .card {
      flex-direction: column !important;
      z-index: 1;
      .image-block {
        width: 100% !important;
        .category {
          position: absolute !important;
          padding: 0.1rem 0.4rem !important;
          background-color: var(--primary-font-color) !important;
          color: var(--fourth-category-color);
          font-size: 0.72em;
        }
      }
      .about {
        padding: 0 0 0 4% !important;

        .text {
          --snup: 3 !important;
          color: var(--secondary-font-color);
          font-size: 0.783em;
        }
        .time {
          color: var(--fourth-date-color);
          font-size: 0.688em;
        }
      }
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7) {
        align-self: end;
        padding: 0 !important;
        background-color: inherit !important;
        .image-block {
          .category {
            position: relative !important;
            padding: 0 !important;
            background-color: inherit !important;
            color: var(--category-color);
          }
          .image {
            display: none;
          }
        }
        .about {
          padding: 0 !important;
          font-size: 1em;
          .text {
            --snup: 5 !important;
            padding-top: 0.5rem;
            color: var(--primary-font-color);
            font-size: 0.9em;
          }
          .time {
            color: var(--date-color);
            font-size: 0.79em;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .fourth-Bar {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(9, minmax(0, 70px));
    grid-template-areas:
      "card-1 card-1 card-1 card-4 card-4 card-4"
      "card-1 card-1 card-1 card-4 card-4 card-4"
      "card-1 card-1 card-1 card-5 card-5 card-5"
      "card-2 card-2 card-2 card-5 card-5 card-5"
      "card-2 card-2 card-2 card-6 card-6 card-6"
      "card-2 card-2 card-2 card-6 card-6 card-6"
      "card-3 card-3 card-3 card-7 card-7 card-7"
      "card-3 card-3 card-3 card-7 card-7 card-7"
      "card-3 card-3 card-3 . . .";
    grid-row-gap: 0.5em;
    grid-column-gap: 2em;
    .card {
      .about {
        .text {
          --snup: 3 !important;
        }
      }
      &:nth-child(4),
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7) {
        .about {
          .text {
            --snup: 5 !important;
          }
        }
      }
    }

    .decor-shield {
      top: -2%;
      width: 50vw;
      height: 105%;
    }
  }
}
</style>
